const GET_AZURE_ACTIVITY_LOGS = "GET_AZURE_ACTIVITY_LOGS";
const GET_AZURE_ACTIVITY_LOGS_SUCCESS = "GET_AZURE_ACTIVITY_LOGS_SUCCESS";
const GET_AZURE_ACTIVITY_LOGS_ERROR = "GET_AZURE_ACTIVITY_LOGS_ERROR";

export {
  GET_AZURE_ACTIVITY_LOGS,
  GET_AZURE_ACTIVITY_LOGS_SUCCESS,
  GET_AZURE_ACTIVITY_LOGS_ERROR,
};
